import HARDCODE from '../../../business-const/HardCode/HardCode'



export const informouObjetivos = (values) => {

    let informou = false

    values.objetivosPrincipaisPreocupacoesPFCMLP?.forEach( (linhaObjetivosPrincipaisPreocupacoesPFCMLP,
        indexObjetivosPrincipaisPreocupacoesPFCMLP) => {

        if (
                linhaObjetivosPrincipaisPreocupacoesPFCMLP.richText &&
                linhaObjetivosPrincipaisPreocupacoesPFCMLP.richText !== HARDCODE.richTextEditorVazio) {

            informou = true
        }
    })

    return informou
}